import moment from 'moment';

/**
 * momentからString(YYYY/MM/DD)への変換
 *
 * @param momentDate
 * @returns
 */
export const convertMomentToStr = (momentDate: any) => {
  var date = moment(momentDate).toDate();
  // console.log(date.getMonth())
  return (
    date.getFullYear() +
    '/' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '/' +
    ('0' + date.getDate()).slice(-2)
  );
};
